import { clamp, Easing } from '@/lib/anim/easing';

import { T } from './storyboard';

// Ch. 02 - the turn: the counter-claim, stated plainly on an empty stage.
export function Scene2Turn({ time }: { time: number }) {
  const [start, end] = T.turn;
  if (time < start || time > end) return null;
  const localTime = time - start;
  const duration = end - start;

  const inT = Easing.easeOutCubic(clamp(localTime / 0.8, 0, 1));
  const outT = clamp((localTime - (duration - 0.7)) / 0.7, 0, 1);
  const opacity = inT * (1 - outT);
  const ty = (1 - inT) * 18 - outT * 6;
  const underline = clamp((localTime - 1.4) / 1.2, 0, 1);

  return (
    <>
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '48%',
          transform: `translate(-50%, calc(-50% + ${ty}px))`,
          opacity,
          width: 1280,
          textAlign: 'center',
          fontFamily: '"Cormorant Garamond", "Georgia", serif',
          fontWeight: 300,
          fontSize: 68,
          lineHeight: 1.22,
          color: 'var(--assay-text-primary)',
          letterSpacing: '-0.02em',
          zIndex: 2,
        }}
      >
        The best opportunities come from{' '}
        <span style={{ position: 'relative', display: 'inline-block' }}>
          <em style={{ color: 'var(--assay-ore-light)', fontWeight: 300 }}>
            people who already know your name
          </em>
          <span
            style={{
              position: 'absolute',
              left: 6,
              right: 6,
              bottom: -10,
              height: 1,
              background: 'var(--assay-ore)',
              transformOrigin: 'left',
              transform: `scaleX(${underline})`,
              boxShadow: '0 0 10px rgba(196,152,58,0.4)',
            }}
          />
        </span>
        .
      </div>

      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '70%',
          transform: 'translate(-50%, -50%)',
          opacity: clamp((localTime - 1.5) / 0.5, 0, 1) * (1 - outT),
          fontFamily: '"DM Mono", monospace',
          fontSize: 13,
          letterSpacing: '0.28em',
          textTransform: 'uppercase',
          color: 'var(--assay-text-label)',
          zIndex: 2,
        }}
      >
        The veins with the highest signal.
      </div>
    </>
  );
}
